var React = require('react');

function HomeNetworkLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M41 18.027a1 1 0 00-1 1v18H21a1 1 0 100 2h19a2 2 0 002-2v-18a1 1 0 00-1-1zm-26 0a1 1 0 011 1v7a1 1 0 11-2 0v-7a1 1 0 011-1z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M30.166 4.382a3.894 3.894 0 00-4.37.026L8.407 17.22a1 1 0 001.187 1.61l17.37-12.799a1.894 1.894 0 012.074 0l17.37 12.8a1 1 0 101.186-1.61L30.203 4.407a.985.985 0 00-.037-.026zM.445 32.053a17.982 17.982 0 0119.968 0 1 1 0 11-1.11 1.664 15.982 15.982 0 00-17.748 0 1 1 0 01-1.11-1.664zm4.438 5.142a10 10 0 0111.094 0 1 1 0 01-1.11 1.664 8 8 0 00-8.874 0 1 1 0 01-1.11-1.664z","key":1}),React.createElement("path",{"d":"M12 42.777a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z","key":2})]);
}

HomeNetworkLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = HomeNetworkLight;

HomeNetworkLight.default = HomeNetworkLight;
